const searchParamIncludesOne = (...searchParams) => {
  return traffic => {
    const urlObject = new URL(traffic.url.toLowerCase())
    return searchParams.some(searchParam => {
      const value = urlObject.searchParams.get(searchParam)
      return value !== null
    })
  }
}

export default searchParamIncludesOne



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/searchParamIncludesOne.js